import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://6d5249f331d19db1f704aef70b7df1d6@o4510278675660800.ingest.us.sentry.io/4510281490366464",
    integrations: [Sentry.replayIntegration()],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    sendDefaultPii: false,
  });
}
